var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 5,
    fill: "#EFAA2D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25644 8.20856H11.2412V8.63122H12.5506V2.46133H11.2412V7.40884H9.25644V8.20856ZM7.07274 5.8011C8.65147 5.80525 9.72053 5.20442 9.72882 4.21823C9.72053 3.25691 8.65147 2.62707 7.07274 2.62707C5.46501 2.62707 4.40423 3.25691 4.40838 4.21823C4.40423 5.20442 5.46501 5.80525 7.07274 5.8011ZM7.07274 3.48895C7.94705 3.48895 8.50644 3.77072 8.50644 4.21823C8.50644 4.66575 7.94705 4.93923 7.07274 4.93923C6.19014 4.93923 5.63075 4.66575 5.63904 4.21823C5.63075 3.77072 6.19014 3.48895 7.07274 3.48895ZM7.66528 8.65193V7.12293C8.64318 7.06906 9.63766 6.99033 10.6073 6.85773L10.5368 6.03729C8.26197 6.26519 5.70119 6.28177 3.65009 6.27762L3.79512 7.19337C4.5907 7.19751 5.46501 7.19751 6.37246 7.17265V8.65193H7.66528ZM6.52578 11.3453H12.5506V8.96685H5.20396V9.85773H11.2537V10.4917H5.24539V12.9489H12.8324V12.0249H6.52578V11.3453Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWIcon);
export default __webpack_public_path__ + "static/media/WIcon.e844207b6746a67b90d4fe2a3a55139f.svg";
export { ForwardRef as ReactComponent };